module.exports = __webpack_public_path__ + "static/media/perksIcon3.ad900c06.svg";